import { FC, HTMLAttributes } from 'react'

import { Slot, Slottable } from '@radix-ui/react-slot'

import { IconArrowLeft } from '~/components/ui/icons/arrow-left'
import { twMerge } from '~/lib/utils'

type Props = {
  asChild?: boolean
} & HTMLAttributes<HTMLButtonElement>

export const BackButton: FC<Props> = ({
  className,
  children,
  asChild = false,
  ...props
}) => {
  const Comp = asChild ? Slot : 'button'

  return (
    <Comp
      className={twMerge(
        'inline-flex h-11 items-center justify-center gap-x-1 rounded border border-grayBtn py-2 pl-2 pr-4 text-body-s',
        className,
      )}
      {...props}
    >
      <IconArrowLeft />
      <Slottable>{children}</Slottable>
    </Comp>
  )
}
